import { useWidgetDndContextData } from "src/context/WidgetDndContext";
import { HEADING_TYPE_IMAGE, IS_TEXT_ON_IMAGE } from "../constant";
import { getHeadingStyle } from "../utils";
import { isMobileDevice } from "src/components/WidgetMaker/WidgetDnD/isMobileDevice";
import { COMMON_LAYOUT_TYPE } from "../../ListPresentation/components/Testimonials/Constants";
import { RICH_TEXT_IMAGE } from "src/constants/builderConstants";

function FilterHeading(props) {
  const { isCollection, selectedCatCol } = props;
  const {
    widgetContextState: { pageStyle },
  } = useWidgetDndContextData();
  const isMobile = isMobileDevice();
  const currentWidgetType = isCollection ? pageStyle?.caligraphyCollection : pageStyle?.caligraphyCategory;
  const currentHeadingType = currentWidgetType?.heading_type
  const isBannerFullWidth = currentWidgetType?.isBannerFullWidth;
  const textPostion = currentWidgetType?.text_placement === IS_TEXT_ON_IMAGE;
  const isFullWidthHeading = pageStyle?.sortAndFilter?.layout_desktop !== COMMON_LAYOUT_TYPE.ONE;
  const textAlignment = currentWidgetType?.text_alignment

  function renderImageHeading() {
    return (
      <>
        <div style={{ margin: isBannerFullWidth ? '0 -1rem' : '0', height: currentWidgetType.height }}  className={`tw-relative ${!isMobile ? 'tw-pb-[20px]' : ''}`}>
          <img src={selectedCatCol?.data?.image_url || RICH_TEXT_IMAGE} height={currentWidgetType.height} className="tw-object-cover" width={'100%'} />
          {textPostion && <div>{renderTextHeading(true)}</div>}
          <div
            className={`tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-[1] tw-bg-black tw-pb-[20px]`}
            style={{
              background: `rgba(0,0,0, 0.2)`,
              height: currentWidgetType.height,
            }}
          ></div>
        </div>
      </>
    )
  }

  function renderTextHeading(isTextOnImage = false) {
    return (
      <div style={{ ...getHeadingStyle(currentWidgetType, isMobile), }}
        className={`${(isFullWidthHeading && !isTextOnImage) ? `tw-py-[24px] tw-flex tw-flex-col tw-justify-center tw-border-b tw-border-solid tw-border-[#111c3629] ${!isMobile ? 'tw-min-h-[108px]' : ''}` : ''}
         ${isTextOnImage ? `tw-h-[100%] tw-w-[100%] !tw-z-20  tw-absolute tw-top-[0px]  tw-flex tw-flex-col tw-justify-center ${textAlignment === 'left' ? 'tw-items-start' : 'tw-text-center'}` : ''}
        `}>
        <div className={`${(!isFullWidthHeading && isMobile) ? 'tw-py-[24px] tw-border-b tw-border-solid tw-border-[#111c3629]' : ''}`}>{selectedCatCol?.data?.name || 'COLLECTION'}</div>
      </div>
    )
  }

  return (
    currentHeadingType === HEADING_TYPE_IMAGE ? renderImageHeading() : renderTextHeading()
  )
}

export default FilterHeading